import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRoleDataService } from './user-role-data.service';
import { UserRoleAssignableService } from "./user-role-assignable.service";


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    { provide: UserRoleDataService, useClass: UserRoleDataService, multi: false },
    { provide: UserRoleAssignableService, useClass: UserRoleAssignableService, multi: false }
  ]
})
export class UserRoleDataModule { }
